import { useRuntimeConfig } from '#imports'

import type { DataLayerEvent } from '../../../types'

/**
 * Logs event to console instead of pushing to GTM dataLayer.
 * Only logs when GTM_EVENTS_MIGRATION_LOGS_ACTIVATED feature flag is enabled.
 *
 * @param event - The event data that would be pushed to dataLayer
 */
export function logEventToConsole(event: DataLayerEvent): void {
  if (!import.meta.client) return

  const {
    public: { GTM_EVENTS_MIGRATION_LOGS_ACTIVATED },
  } = useRuntimeConfig()

  if (!GTM_EVENTS_MIGRATION_LOGS_ACTIVATED) return

  // eslint-disable-next-line no-console
  console.log('[GTM Staging]', event)
}

export function pushEventToStagingDataLayer(event: DataLayerEvent) {
  if (!import.meta.client) return

  const {
    public: { GTM_EVENTS_MIGRATION_LOGS_ACTIVATED },
  } = useRuntimeConfig()

  if (!GTM_EVENTS_MIGRATION_LOGS_ACTIVATED) return

  window.stagingDataLayer ??= []
  window.stagingDataLayer.push(event)
}
